import { useEffect, useState } from 'react';
import api from '../../lib/api';

function hexToHSL(hex) {
  hex = hex.replace('#', '');
  const r = parseInt(hex.substring(0, 2), 16) / 255;
  const g = parseInt(hex.substring(2, 4), 16) / 255;
  const b = parseInt(hex.substring(4, 6), 16) / 255;
  const max = Math.max(r, g, b), min = Math.min(r, g, b);
  let h = 0, s = 0, l = (max + min) / 2;
  if (max !== min) {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r: h = ((g - b) / d + (g < b ? 6 : 0)) / 6; break;
      case g: h = ((b - r) / d + 2) / 6; break;
      case b: h = ((r - g) / d + 4) / 6; break;
      default: break;
    }
  }
  return `${Math.round(h * 360)} ${Math.round(s * 100)}% ${Math.round(l * 100)}%`;
}

export const ThemeApplier = () => {
  const [applied, setApplied] = useState(false);

  useEffect(() => {
    if (applied) return;
    api.get('/theme').then(res => {
      const colors = res.data?.theme_colors || {};

      const root = document.documentElement;

      // Design theme layer (typography / radius / density / component tokens)
      const designTheme = colors.design_theme;
      if (designTheme) {
        root.setAttribute('data-design-theme', designTheme);
      }

      if (colors.accent) {
        const accentHSL = hexToHSL(colors.accent);
        root.style.setProperty('--gold', accentHSL);
        root.style.setProperty('--accent', accentHSL);
        root.style.setProperty('--ring', accentHSL);
      }

      setApplied(true);
    }).catch(() => {});
  }, [applied]);

  return null;
};
